export default __webpack_public_path__ + "static/media/landing-bg.94bf770d.jpg";